import React from 'react';
import { Form, Input, Button, Row, Col, FormInstance } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { ValidationErrors } from 'constants/validations';

const { Item } = Form;

export interface SignInFormData {
  username?: string;
  email?: string;
  password: string;
}

export interface SignInFormProps {
  form: FormInstance;
  onFinish: (values: SignInFormData) => void;
  loading?: boolean;
  usernameField?: 'username' | 'email';
  onForgotPassword?: () => void;
  submitButtonText?: string;
  forgotPasswordText?: string;
  showForgotPassword?: boolean;
  extraContent?: React.ReactNode;
}

export const SignInForm: React.FC<SignInFormProps> = ({
  form,
  onFinish,
  loading = false,
  usernameField = 'username',
  onForgotPassword,
  submitButtonText = 'Sign In',
  forgotPasswordText = 'Forgot password?',
  showForgotPassword = true,
  extraContent,
}) => {
  const usernameLabel = usernameField === 'email' ? 'Email *' : 'Username/ Email *';

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <Item
                label={usernameLabel}
                name={usernameField}
                rules={[
                  {
                    required: true,
                    message: ValidationErrors.required(usernameField === 'email' ? 'Email' : 'Username/ Email'),
                  },
                ]}
              >
                <Input size="large" />
              </Item>
            </Col>
            <Col span={24}>
              <Item
                name="password"
                label="Password *"
                rules={[
                  {
                    required: true,
                    message: ValidationErrors.required('Password'),
                  },
                ]}
              >
                <Input.Password
                  iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                  size="large"
                />
              </Item>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 0]}>
            {showForgotPassword && onForgotPassword && (
              <span
                onClick={onForgotPassword}
                style={{
                  color: '#05796B',
                  cursor: 'pointer',
                  marginBottom: '16px',
                  fontSize: '14px',
                }}
              >
                {forgotPasswordText}
              </span>
            )}
            <Col span={24}>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                block
                loading={loading}
                style={{
                  backgroundColor: '#05796B',
                  borderColor: '#05796B',
                  height: '48px',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
              >
                {submitButtonText}
              </Button>
            </Col>
            {extraContent && (
              <Col span={24} style={{ marginTop: '16px' }}>
                {extraContent}
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
